export const DefaultThemeColors = {
         tabIconSelected: "#1275d8",
         tabIconDefault: "#333",
         tabBarBorderDefault: "#d20e0e",
         tabBg: "#fff",
         statusBarBg: "#065cb1",
         headerBg: "#1275d8",
         headerTint: "#fff",
         primaryBg: "#fff",
         secondaryBg: "#eee",
         infoBg: "#1771c4",
         primaryText: "#333111",
         secondayText: "#666",
         infoText: "#1771c4",
         primaryBorder: "#d20e0e",
         secondaryBorder: "#eee",
         btnPrimaryBg: "#1771c4",
         btnPrimaryText: "#fff",
       };

export const DarkThemeColors = {
         tabIconSelected: "#1275d8",
         tabIconDefault: "#ffffff",
         tabBarBorderDefault: "#d20e0e",
         tabBg: "#181818",
         statusBarBg: "#000000",
         headerBg: "#181818",
         headerTint: "#ffffff",
         primaryBg: "#000",
         secondaryBg: "#222",
         infoBg: "#666",
         primaryText: "#fff",
         secondayText: "#fff",
         infoText: "#fff",
         primaryBorder: "#d20e0e",
         btnPrimaryBg: "#333",
         btnPrimaryText: "#fff",
       };

       export const ThemeOne2 = {
       leftbar:'#F3A138',
       body: '#ffd11a',

       top1:'#ffaa00',
       top2:'#ffb100',
       top3:'#ffb800',
       top4:'#ffbe00',
       top5:'#ffc500',
       top6:'#ffcc00',
       top7:'#ffd914',
       top8:'#ffe529',
       top9:'#ffef3d',
      top10:'#fff852',
      top11:'#ffff66',

      };

      export const ThemeOne = {
        leftbar:'#0373BB',
        body: '#039BE5',
 
        top1:'#0157bf',
        top2:'#0277BD',
        top3:'#0288D1',
        top4:'#039BE5',
        top5:'#03A9F4',
        top6:'#29B6F6',
        top7:'#4FC3F7',
        top8:'#81D4FA',
        top9:'#B3E5FC',
       top10:'#E1F5FE',
       top11:'#E1Ffff',
 
       };

       export const ThemeOne22 = {
        leftbar:'#1B5E20',
          body: '#43A047',
 
        top1:'#1B5E20',
        top2:'#2E7D32',
        top3:'#388E3C',
        top4:'#43A047',
        top5:'#4CAF50',
        top6:'#66BB6A',
        top7:'#81C784',
        top8:'#A5D6A7',
        top9:'#C8E6C9',
       top10:'#E8F5E9',
       top11:'#E8F5ff',
 
       };

       export const ThemeTwo = {
        leftbar:'#827717',
        body: '#C0CA33',
 
        top1:'#827717',
        top2:'#9E9D24',
        top3:'#AFB42B ',
        top4:'#C0CA33',
        top5:'#CDDC39',
        top6:'#D4E157',
        top7:'#DCE775',
        top8:'#E6EE9C',
        top9:'#F0F4C3',
       top10:'#F9FBE7',
       top11:'#F9FBff',
 
       };